import { useQuery } from '@tanstack/react-query';
import {
  getAllDesignations,
  getDesignationsPaged,
  DesignationListDto,
  DesignationListParams,
  DesignationListResult,
} from '../services/designationService';
import { configurationKeys } from '../queryKeys';

export function useDesignations(tenantId: string) {
  const { data, isLoading, isFetching, isError, error, refetch } = useQuery<
    DesignationListDto[],
    Error
  >({
    queryKey: configurationKeys.designations.list(tenantId),
    queryFn: () => getAllDesignations(tenantId),
    enabled: Boolean(tenantId),
    staleTime: 30_000,
  });

  return {
    designations: data ?? [],
    isLoading,
    isFetching,
    isError,
    error: error ?? null,
    refetch,
  };
}

/**
 * Server-side paginated/searchable variant, used only by the Designations
 * Configuration screen's table. `useDesignations` above is left untouched — it
 * still serves dropdown selects elsewhere unpaginated.
 */
export function useDesignationsList(params: DesignationListParams) {
  const { data, isLoading, isFetching, isError, error, refetch } = useQuery<
    DesignationListResult,
    Error
  >({
    queryKey: configurationKeys.designations.paged(params),
    queryFn: () => getDesignationsPaged(params),
    enabled: Boolean(params.tenantId),
    staleTime: 30_000,
    placeholderData: (previous) => previous,
  });

  return {
    designations: data?.items ?? [],
    totalCount: data?.totalCount ?? 0,
    isLoading,
    isFetching,
    isError,
    error: error ?? null,
    refetch,
  };
}
